<template>
    <dialog-modal
        :variant="variant"
        v-bind="$dialogsProps"
        @hide="onModalHideCustom"
        @hidden="onModalHidden"
        ref="modal">
        <div><p v-html="message"></p></div>
        <b-checkbox class="mt-3" v-model="cascade">Delete user related reacts</b-checkbox>
    </dialog-modal>
</template>

<script>
import withBModal from "@modules/dialogs/mixins/withBModal";

export default {
    name: "DeleteUserDialog",
    mixins: [withBModal],
    props: {
        okTitle: {default: 'DELETE'},
        variant: {default: 'danger'},
        message: {default: 'Do you want to delete User?'}
    },
    data() {
        return {
            cascade: false
        }
    },
    methods: {
        onModalHideCustom(e) {
            e.cascade = this.cascade
            this.onModalHide(e)
        }
    }
}
</script>

<style scoped>

</style>
